
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Log environment variables for debugging
console.log('Environment variables:', {
  apiUrl: import.meta.env.VITE_API_URL,
  mode: import.meta.env.MODE
});

// Ensure React is properly initialized for the app
createRoot(document.getElementById("root")!).render(<App />);
